import { json } from 'react-router-dom'
import { AxiosError } from 'axios'
import { validateRequestToken } from '@/routes/resetPassword/actions.ts'

// eslint-disable-next-line
export async function ResetPasswordTokenLoader({ params }: { params: any }) {
  const token = params.token
  if (!token) return null
  try {
    const response = await validateRequestToken(token)
    return json(response.data)
  } catch (error) {
    if (error instanceof AxiosError) {
      return null
    }
  }
}
